import { render } from "./Card.vue?vue&type=template&id=61c00127&scoped=true&ts=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=61c00127&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c00127"]])

export default __exports__